(function () {
    "use strict";

    angular.module("app")
        .controller("TransferChecklist",
            [
                "$scope", "cfpLoadingBar", "toaster", "PermissionService", "SharedData", "SeasonService", "WorkflowService",
                "PrototypeService", "TransferChecklistService", "DocumentService", transferChecklistController
            ]);

    function transferChecklistController($scope, cfpLoadingBar, toaster, permissionService, sharedData, seasonService, workflowService,
        prototypeService, transferChecklistService, documentService) {
        var model = this;

        $scope.params = {};

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        $scope.export = function () {

            transferChecklistService.exportChecklist($scope.params).then(function(data) {
                if (data && data.length > 0)
                    documentService.openTempDocument(data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "Transfer Checklist Export.xlsx");
                else
                    toaster.pop({ type: "error", title: "Error!", body: "An unexpected error occurred exporting the file.", timeout: 5000 });
                return;
            });
        };

        $scope.import = function(e) {
            var file = e.files[0];
           
            transferChecklistService.upload(file)
                .then(function () {
                    toaster.pop({ type: "success", title: "Upload Completed", body: "<a href='/upload-queue'>Upload successful! Click here to see upload progress and results.</a>.", bodyOutputType: "trustedHtml", timeout: 5000 });
                }, function () {
                    toaster.pop({ type: "error", title: "File Upload Error", body: "There was an error while uploading your file.", timeout: 5000 });
                });

            //clear file select
            $scope.documentInterface = {};
        };

        $scope.loadBrandData = function () {
            var brand = _.find($scope.brands, function (b) { return b.BrandId === $scope.params.brandId });

            $scope.params.divisionKey = null;
            $scope.params.prototypeGroupId = null;

            if (brand) {
                $scope.sapBrandId = brand.SAPBrandId;
                $scope.getSeasonsByBrand($scope.params.brandId);
                workflowService.getWFGroups($scope.params.brandId, 4).then(function (data) { $scope.prototypeGroups = data; });
            } else {
                $scope.sapBrandId = null;
                $scope.seasons = [];
                $scope.prototypeGroups = [];
            }
            cfpLoadingBar.complete();
        };

        $scope.getSeasonsByBrand = function (brandId) {
            return seasonService.getSeasonsByBrand(brandId).then(function (data) {
                $scope.seasons = data;
            });
        };

        model.init = function () {
            $scope.canImport = permissionService.canEditTransferChecklist();

            sharedData.getUserDefaults().then(function (userDefaults) {
                if (userDefaults) {
                    $scope.brands = userDefaults.brands;
                    $scope.seasons = userDefaults.seasons;
                    $scope.params.brandId = userDefaults.brandId;
                    $scope.params.seasonId = userDefaults.seasonId;

                    if (userDefaults.brandId) {
                        $scope.loadBrandData();
                        $scope.params.divisionKey = userDefaults.divisionKey;
                    } else
                        cfpLoadingBar.complete();
                }
            });

        };

        //model.init();
    }
})();
